// extracted by mini-css-extract-plugin
module.exports = {"notification":"style_notification__3qSDV","unRead":"style_unRead__29iJ2","icon":"style_icon__3Izad","texts":"style_texts__cpaJO"};